<template>
    <div class="col text-center">
        <div
          class="spinner-border text-secondary"
          style="width: 3rem; height: 3rem;"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
</template>
<script>
export default {
    name: 'LoaderComponent'
}
</script>